import React, {useContext, useState} from "react";

// Context
import {UserAuthenticationContext} from "../../../Context/UserAuthenticationContext";

// Components
import InputField from "../../Inputs/InputField";
import ButtonPill from "../../Buttons/ButtonPill";

// Hooks
import {useUpdatePassword} from "../../../Hooks/User/useUpdatePassword";
import SuccessMessage from "../../Text/SuccessMessage";
import ErrorMessage from "../../Text/ErrorMessage";

const ChangePasswordForm: React.FC = () => {
    const
        {userData, getValidAccessToken} = useContext(UserAuthenticationContext),

        [currentPw, setCurrentPw] = useState(""),
        [newPw, setNewPw] = useState(""),
        [confirmPw, setConfirmPw] = useState(""),

        {
            changePassword,
            isUpdating,
            errorMessage,
            success,
            clearError,
            clearSuccess,
        } = useUpdatePassword({
            getValidAccessToken
        }),

        handleSubmit = async (e: React.FormEvent) => {
            e.preventDefault();
            clearSuccess();
            const res = await changePassword(currentPw, newPw, confirmPw);
            // you can inspect res.code if you want specific UI reactions
        },

        onFieldChange = (setter: (v: string) => void) =>
            (e: React.ChangeEvent<HTMLInputElement>) => {
                setter(e.target.value);
                if (errorMessage) clearError();
                if (success) clearSuccess();
            };

    return (
        <form onSubmit={handleSubmit} className="form form--change-pw">
            <h3>Change Password</h3>

            <InputField
                type="password"
                name="currentPassword"
                value={currentPw}
                label="Current Password"
                onChange={onFieldChange(setCurrentPw)}
            />

            <InputField
                type="password"
                name="newPassword"
                value={newPw}
                label="New Password"
                onChange={onFieldChange(setNewPw)}
            />

            <InputField
                type="password"
                name="confirmPassword"
                value={confirmPw}
                label="Confirm New Password"
                onChange={onFieldChange(setConfirmPw)}
                errorMessage={errorMessage || undefined}
                hasError={!!errorMessage}
            />

            <ButtonPill
                label={isUpdating ? "Updating..." : "Update Password"}
                type="submit"
                disabled={isUpdating}
            />

            {errorMessage && <ErrorMessage errorMessage={errorMessage} />}
            {success && <SuccessMessage successMessage="Password updated successfully" />}
        </form>
    );
};

export default ChangePasswordForm;
